export default __webpack_public_path__ + "static/784-c8b345d84488c02a78f2659e523dfb78.gif";